import { invokeAssetSearch, onAssetSearchStarted } from '../actions/assetSearchActions';
import { orchestrator } from 'satcheljs';
import { getSearchableAssets, getSearchableAsset } from '../assetSearchRegistry';
import type { SearchableAsset } from '../SearchableAsset';

/**
 * Kicks off an asset search
 */
export default orchestrator(invokeAssetSearch, ({ searchRequest, assetType }) => {
    let searchingAssets: SearchableAsset[] = [];
    if (assetType) {
        const asset = getSearchableAsset(assetType);
        asset && searchingAssets.push(asset);
    } else {
        searchingAssets = getSearchableAssets();
    }

    searchingAssets.forEach(asset => {
        if (asset.searchAsset) {
            onAssetSearchStarted(searchRequest, asset.type);
            asset.searchAsset(searchRequest);
        }
    });
});
